import React from "react";
import { useDispatch, useSelector } from "react-redux";

import TeamImage from "../../../assets/img/product-team.svg";

import ButtonLink from "../../../components/button/ButtonLink";
import ColumnLoader from "../../../components/loading/columnLoader";
import NumberFormat from "react-number-format";
import VerticallyCenteredModal from "../../../components/modal/VerticallyCenteredModal";
import { getProductDetailAction } from "../../../../redux/action/serviceAction";

function ProductModule() {
  const dispatch = useDispatch();
  const { dataTypeProduct } = useSelector((state) => state.landingpage);
  const {
    loadingGetFeaturedProduct,
    dataGetFeaturedProduct,
    loadingDetailProduct,
    dataDetailProduct,
  } = useSelector((state) => state.service);
  const [modalShow, setModalShow] = React.useState(false);
  const getProductDetail = (id) => {
    dispatch(getProductDetailAction(id));
    setModalShow(true);
  };

  return (
    <div className="p-d-flex p-jc-center">
      <div className="container product-page col-lg-10 col-md-12 col-sm-12">
        <div className="top-section">
          <div className="text-section">
            <h1>Layanan IRIS</h1>
            <p>
              IRIS memiliki visi menjadi platform penyebaran media rilis secara
              terintegrasi yang terkemuka di Indonesia. Menjadi pelopor dalam
              pertumbuhan media online dengan memberikan solusi berbasis hasil
              untuk membantu bisnis Anda lebih terpercaya dan kredibel di mata
              masyarakat.
            </p>
            <ButtonLink link="/create-account" type="rounded" label="Daftar" />
          </div>
          <div className="image-section">
            <img src={TeamImage} alt="image_team" />
          </div>
        </div>
        <div className="homepage-service-section">
          {dataTypeProduct?.map((item) => (
            <div className="homepage-service-item" key={item?.id}>
              <img
                className="image-service-section"
                src={item?.image}
                alt={`banner ${item.title}`}
              />
              <div className="text-section">
                <h4>{item?.title}</h4>
                <p>{item?.description}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="homepage-product-section">
          {loadingGetFeaturedProduct ? (
            <ColumnLoader style={{ margin: "0 20px" }} />
          ) : (
            <>
              <h4>PRODUK</h4>
              <div className="homepage-product-section__list">
                {dataGetFeaturedProduct?.map((product) => (
                  <div
                    key={product.id}
                    className="homepage-product-section__item"
                  >
                    <div className="homepage-product-section__item-image">
                      <img src={product.image} alt="Gambar produk" />
                    </div>
                    <div className="homepage-product-section__item-info">
                      <h4>{product.name}</h4>
                      <div className="homepage-product-section__item-info__price">
                        {product.priceDiscount !== "" &&
                        parseInt(product.priceDiscount) !== 0 ? (
                          <>
                            <h3 className="homepage-product-section__item-info__price-normal-strike">
                              <NumberFormat
                                prefix={"Rp "}
                                thousandSeparator={"."}
                                decimalSeparator={","}
                                displayType="text"
                                value={product?.price}
                              />
                            </h3>
                            <h3 className="homepage-product-section__item-info__price-discount">
                              <NumberFormat
                                prefix={"Rp "}
                                thousandSeparator={"."}
                                decimalSeparator={","}
                                displayType="text"
                                value={product?.priceDiscount}
                              />
                            </h3>
                          </>
                        ) : (
                          <h3 className="homepage-product-section__item-info__price-normal">
                            <NumberFormat
                              prefix={"Rp "}
                              thousandSeparator={"."}
                              decimalSeparator={","}
                              displayType="text"
                              value={product?.price}
                            />
                          </h3>
                        )}
                      </div>
                      <p>{product.description}</p>
                    </div>
                    <div className="homepage-product-section__item-button">
                      <button
                        className="p-button"
                        onClick={() => getProductDetail(product?.id)}
                      >
                        PESAN
                      </button>
                    </div>
                  </div>
                ))}
                {loadingDetailProduct ? (
                  ""
                ) : (
                  <VerticallyCenteredModal
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                    data={dataDetailProduct}
                  />
                )}
              </div>
            </>
          )}
        </div>
        <div className="bottom-section">
          <h2>Daftar Gratis Sekarang!</h2>
          <ButtonLink link="/create-account" type="rounded" label="Daftar" />
        </div>
      </div>
    </div>
  );
}

export default ProductModule;
